import cn from 'classnames';
import { transformStringToPath } from '../../../../../../helpers/transformStringToPath';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';
import s from './GuestCard.module.scss';
import { Anchor } from '../../../../../shared/Anchor';
import GuestPhoto from '../../../FestivalProGuestProfileView/GuestProfile/GuestPhoto';

export function getGuestId(guest) {
  if (guest.categories.length <= 1) return guest.id;

  const index = guest.categories.findIndex(
    (category) => category === guest.category,
  );

  return index === -1 ? guest.id : `${guest.id}-${index}`;
}

export default function GuestCard({ guest }) {
  const { sitePath } = useRootSelector(selectPageConfig);
  const guestId = getGuestId(guest);

  return (
    <Anchor
      to={`/our-guests/${transformStringToPath(guest.name)}/${guestId}/`}
      pathPrefix={sitePath}
      className={cn(s.wrapper, 'guest-profile-photo-hover')}
    >
      <div className={s.image}>
        <GuestPhoto
          src={guest.images[guest.category]}
          alt={guest.imageAlt}
          withBorder
        />
      </div>
      <div className={s.textContent}>
        <h4 className={s.name}>{guest.name}</h4>
        {guest.credits[guest.category] && (
          <div className={s.credit}>
            {guest.credits[guest.category].split(';').join(', ')}
          </div>
        )}
        {guest.appearingDates.length > 0 && (
          <div className={s.appearing}>
            Appearing: {guest.appearingDates.join(', ')}
          </div>
        )}
      </div>
    </Anchor>
  );
}
